import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  containerStyle: {
    flex: 1,
  },
  totalCostSectionContainer: {
    paddingBottom: 250,
  },
  upgradeSelectionPaymentContainer: {
    paddingHorizontal: 15,
    paddingBottom: 33,
  },
  upgradeSelectionSectionContainer: theme => ({
    borderBottomWidth: 1,
    borderColor: theme.colors.borderColorThree,
    marginVertical: 30,
    marginBottom: 40,
    paddingBottom: 40,
  }),
  myPlan: theme => ({
    fontSize: 16,
    marginTop: 10,
    marginVertical: 20,
    color: theme.colors.subtitle,
  }),
});
